module.exports = __webpack_public_path__ + "img/car-7.e5e7e06e.png";